const defaultTabsState = () => {
    return {
        userTab: '0',
        partnerTab: '0',
        companyTab: '5',
        providerTab: '0',
        buyersTab: 0,
        collapse: false,
    }
}
export default {
    namespaced: true,
    state: defaultTabsState(),
    mutations: {
        setUserTab(state, userTab) {
            Object.assign(state, { userTab });
        },
        setPartnerTab(state, partnerTab) {
            Object.assign(state, { partnerTab });
        },
        setCompanyTab(state, companyTab) {
            Object.assign(state, { companyTab });
        },
        setProviderTab(state, providerTab) {
            Object.assign(state, { providerTab });
        },
        setBuyersTab(state, buyersTab) {
            Object.assign(state, { buyersTab });
        },
        setCollapse(state, collapse) {
            Object.assign(state, { collapse })
        },
    },
    actions: {}
}